import React from 'react';
import { 
  Search, 
  Monitor, 
  MessageSquare, 
  Star, 
  Lightbulb,
  MapPin
} from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: <MapPin className="w-8 h-8 text-red-500" />,
      title: "SEO",
      description: "Promote your business through digital media - SEO, Google My Business, Google Maps Optimization, Local Search etc - helping gain exposure to new customers."
    },
    {
      icon: <Monitor className="w-8 h-8 text-red-500" />,
      title: "Websites",
      description: "Your website is your first impression. Attract new leads, rank higher in searches and boost your online presence with premium websites and the power of SEO."
    },
    {
      icon: <Search className="w-8 h-8 text-red-500" />,
      title: "Google Ads",
      description: "Google Ads enables targeted ads on search results, helping businesses reach potential clients quickly and affordably through pay-per-click advertising."
    },
    {
      icon: <MessageSquare className="w-8 h-8 text-red-500" />,
      title: "Social Media",
      description: "Harness the power of Social Media! With Azucarai's social set-up and publishing we can post to multiple channels at once and schedule posts ahead of time."
    },
    {
      icon: <Star className="w-8 h-8 text-red-500" />,
      title: "Reputation Management",
      description: "Earn credibility and monitor your reviews with our review generation tool. Communication is key to a long term relationship. We share resources with you to achieve this."
    },
    {
      icon: <Lightbulb className="w-8 h-8 text-red-500" />,
      title: "Tools & Utilities",
      description: "Enhance digital solutions with analytics, keyword research, CRM systems, and more to streamline marketing and gather insights into customer behavior."
    }
  ];

  return (
    <div className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-red-500 font-semibold text-sm uppercase tracking-wider mb-4">
            WHAT WE OFFER
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Digital Marketing Services That Transform
          </h3>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our plans can be customized to include some or all of these services.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-white border border-gray-200 rounded-full flex items-center justify-center mb-6 mx-auto">
                {service.icon}
              </div>
              
              {/* Title */}
              <h4 className="text-xl font-bold text-gray-800 text-center mb-4">
                {service.title}
              </h4>
              
              {/* Description */}
              <p className="text-gray-600 text-center leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;